import { Flex, Heading } from "@chakra-ui/react";
import { InputControl } from "formik-chakra-ui";
import { useCallback, useMemo } from "react";
import * as OrgConfig from "src/generated/hooks/org-config/requests";
import * as OrgService from "src/services/orgService";
import * as RD from "src/types/remoteData";
import { z } from "zod";

export const Form = () => {
  return (
    <Flex direction="column" gap={2}>
      <Heading as="h3" variant="admin">
        Auth0
      </Heading>
      <InputControl
        width="30rem"
        name="auth0.clientId"
        label="Client ID"
        isRequired
      />
    </Flex>
  );
};

export function useForm(): {
  initialValues: RD.RemoteData<Error, FormikType>;
  submit: (values: FormikType) => Promise<void>;
} {
  const { remoteData, update } =
    OrgService.useOrgConfig<OrgConfig.Auth0Config>("Auth0");
  const initialValues = useMemo(() => {
    return remoteData.map((config): FormikType => {
      return {
        auth0: {
          clientId: config?.clientId ?? "",
        },
      };
    });
  }, [remoteData]);

  const submit = useCallback(
    async (values: FormikType) => {
      await update({
        clientId: values.auth0.clientId,
      });
    },
    [update]
  );

  return {
    initialValues,
    submit,
  };
}

export const FormikSchema = z.object({
  auth0: z.object({ clientId: z.string().min(1, "This field is required") }),
});

type FormikType = z.infer<typeof FormikSchema>;
